export default "__VITE_ASSET__b95bca61__"